import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getMeasurementId,
  initGA,
  isAnalyticsEnabled,
  trackPageView,
} from "../utils/analytics";

let scriptInjected = false;

function injectGtagScript(measurementId) {
  if (scriptInjected || typeof document === "undefined") return;
  scriptInjected = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

const GoogleAnalytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    const id = getMeasurementId();
    injectGtagScript(id);
    initGA();
  }, []);

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    const path = `${pathname}${search}`;
    trackPageView(path);
  }, [pathname, search]);

  return null;
};

export default GoogleAnalytics;
